export var ConnectionState;
(function (ConnectionState) {
    ConnectionState["ACTIVE"] = "ACTIVE";
    ConnectionState["ACTIVATING"] = "ACTIVATING";
    ConnectionState["LOADED"] = "LOADED";
    ConnectionState["LOADING"] = "LOADING";
    ConnectionState["INACTIVE"] = "INACTIVE";
})(ConnectionState || (ConnectionState = {}));
export var AudioSessionState;
(function (AudioSessionState) {
    AudioSessionState["UNKNOWN"] = "UNKNOWN";
    AudioSessionState["START"] = "START";
    AudioSessionState["END"] = "END";
})(AudioSessionState || (AudioSessionState = {}));
